'use strict';

var GridBookingMatrixSwitchModeButtonDirective = function GridBookingMatrixSwitchModeButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-booking-matrix-switch-mode-button.html'),
    controller: 'GridBookingMatrixSwitchModeButtonController'
  };
};
GridBookingMatrixSwitchModeButtonDirective.$inject = [];
module.exports = GridBookingMatrixSwitchModeButtonDirective;